import React, { useState } from 'react';
import PinchZoomPanContainer from './PinchZoomPanContainer';
import CloseButton from '../components/CloseButton';

const cities = [
  { name: "Berlin", row: 394, col: 121, lat: 52.5200, lon: 13.4050 },
  { name: "Bielsko", row: 472, col: 216, lat: 49.8224, lon: 19.0469 },
  { name: "Kraków", row: 466, col: 232, lat: 50.0647, lon: 19.9450 },
  { name: "Poznań", row: 400, col: 180, lat: 52.4064, lon: 16.9252 },
  { name: "Warszawa", row: 406, col: 250, lat: 52.2297, lon: 21.0122 },
  { name: "Wrocław", row: 436, col: 181, lat: 51.1079, lon: 17.0385 },
];

function getMeteoDate() {
  const now = new Date();
  now.setHours(now.getHours() - 6);
  let hour = now.getHours();
  if (hour >= 18) hour = 18;
  else if (hour >= 12) hour = 12;
  else if (hour >= 6) hour = 6;
  else hour = 0;
  const YYYY = now.getFullYear();
  const MM = String(now.getMonth() + 1).padStart(2, '0');
  const DD = String(now.getDate()).padStart(2, '0');
  const HH = String(hour).padStart(2, '0');
  return `${YYYY}${MM}${DD}${HH}`;
}

function WeatherPanel({ onClose }) {
  const [modalCity, setModalCity] = useState(null);

  const openModal = (city) => setModalCity(city);
  const closeModal = () => setModalCity(null);

  return (
    <div style={{
      background: '#fff',
      borderRadius: 20,
      padding: 24,
      minWidth: 280,
      boxShadow: '0 2px 18px rgba(0,0,0,0.15)',
      position: 'relative',
      maxWidth: 500,
      width: '90vw'
    }}>
      {!modalCity && (
        <CloseButton onClick={onClose} />
      )}
      <h2 style={{ marginBottom: 24, textAlign: 'center' }}>Wybierz miasto mordo</h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '28px',
        marginBottom: 22
      }}>
        {cities
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(city => (
            <button
              key={city.name}
              onClick={() => openModal(city)}
              style={{
                minHeight: 110,
                fontSize: '1.35rem',
                borderRadius: '18px',
                border: '3px solid #bbb',
                background: '#f5f5f5',
                color: '#222',
                fontWeight: 'bold',
                cursor: 'pointer',
                width: '100%',
                transition: 'all .15s',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,.05)',
                letterSpacing: '0.01em'
              }}
            >
              <span style={{
                fontSize: '2rem',
                fontWeight: 700,
                letterSpacing: '0.01em',
                marginBottom: 4,
                color: '#222'
              }}>
                {city.name}
              </span>
              <span style={{
                fontSize: '1.1em',
                color: '#666',
                marginTop: 8
              }}>
                {city.lat}, {city.lon}
              </span>
            </button>
        ))}
      </div>
      {modalCity && (
        <div style={{
          position: 'fixed',
          inset: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.5)',
          zIndex: 9000,
          display: 'flex',
          flexDirection: 'column'
        }}>
          <CloseButton
            onClick={closeModal}
            style={{ position: 'absolute', top: 18, right: 24 }}
            zIndex={9100}
          />
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}
          >
            <PinchZoomPanContainer
              style={{
                width: '100vw',
                height: '100vh',
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 20,
                  padding: 20
                }}
              >
                <div
                  style={{
                    background: '#fff',
                    borderRadius: 12,
                    padding: 10,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <img
                    src="https://old.meteo.pl/um/metco/leg_um_pl_cbase_256.png"
                    alt="Legenda"
                    style={{
                      maxHeight: '70vh',
                      width: 'auto',
                      userSelect: 'none',
                      display: 'block'
                    }}
                    draggable={false}
                  />
                </div>
                <div
                  style={{
                    background: '#fff',
                    borderRadius: 12,
                    padding: 10,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <img
                    src={`https://old.meteo.pl/um/metco/mgram_pict.php?ntype=0u&fdate=${getMeteoDate()}&row=${modalCity.row}&col=${modalCity.col}&lang=pl`}
                    alt={modalCity.name}
                    style={{
                      maxHeight: '70vh',
                      width: 'auto',
                      userSelect: 'none',
                      display: 'block'
                    }}
                    draggable={false}
                  />
                </div>
              </div>
            </PinchZoomPanContainer>
          </div>
        </div>
      )}
    </div>
  );
}

export default WeatherPanel;